module.exports = __webpack_public_path__ + "static/headshot-3754e6d8a6d493843ed475c5fca0db6d.jpg";